// eslint-disable-next-line import/no-anonymous-default-export
export default {
  header: {
    input: "Search",
    login: "Login",
  },
  hotBar: {
    home: "HOME",
    shop: "SHOP",
    buyers: "BUYERS",
    blog: "BLOG",
    contacts: "CONTACTS",
    menu: "Menu",
    languages: "Languages",
  },
  intro: {
    text: "The revolutionary system of three cameras — much more possibilities and unchanged ease of use",
    btn: "To the catalog",
  },
  category: {
    title: "Store categories",
  },
  discount: {
    title: "DISCOUNT ON ACCRSSORIES",
    btn: "Review",
  },
  catalog: {
    title: "Catalog of goods",
  },
  product: {
    btn: "Buy",
  },
  blog: {
    title: "Blog",
    titlecard1: "Modern camera",
    titlecard2: "Online music service",
    titlecard3: "Monitor your health",
    text1: "Take incredible photos with the redesigned 12MP camera",
    text2: "Listen to music wherever you like in the new app",
    text3: "On a walk, at work, always monitoring your condition",
    details: "DETAILS",
  },
  footer: {
    follow: "Follow us",
  },
};
